import { render, staticRenderFns } from "./ProductListUnitsTable.vue?vue&type=template&id=4d272297&"
import script from "./ProductListUnitsTable.vue?vue&type=script&lang=ts&"
export * from "./ProductListUnitsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports